export const LIST_COLLECTIONS_REQUEST = 'LIST_COLLECTIONS_REQUEST';
export const COLLECTION_LIST_REQUESTING = 'COLLECTION_LIST_REQUESTING';
export const LIST_COLLECTIONS_SUCCESS = 'LIST_COLLECTIONS_SUCCESS';
export const RESET_COLLECTION_ISFETCHING = 'RESET_COLLECTION_ISFETCHING';
export const GET_COLLECTION_SUCCESS = 'GET_COLLECTION_SUCCESS';
